import * as React from 'react';
import type { SVGProps } from 'react';
const SvgETransportDocument = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#616061" d="M7 0H2v16h12V7H7z" />
    <path fill="#616061" d="M9 0v5h5z" />
  </svg>
);
export default SvgETransportDocument;
